const DatapointProperty= {
  CATEGORY: "Qual. Category",
  LANGUAGE: "Language"
};
export default DatapointProperty;